import { createSelector } from '@reduxjs/toolkit';

export const selectGeneralSlice = (state) => state.general;

export const selectIsSidePanelOpen = createSelector([selectGeneralSlice], (generalSlice) => generalSlice.isSidePanelOpen);
export const selectIsWindowDisconnectedFromSharedWorker = createSelector(
    [selectGeneralSlice],
    (generalSlice) => generalSlice.isWindowDisconnectedFromSharedWorker
);
export const selectIsSharedWorkerDead = createSelector([selectGeneralSlice], (generalSlice) => generalSlice.isSharedWorkerDead);

export const selectReconnectToSharedWorker = createSelector([selectGeneralSlice], (generalSlice) => generalSlice.reconnectToSharedWorker);
